import React, { useEffect, useRef } from 'react';

// The intake form's text-message choice: two radios, neither selected until
// the visitor picks one. Both wordings come from the intake GET
// (smsConsentText, smsDeclineText) and are shown exactly as sent; the server
// stores its own rendering of the Yes text, never anything from the client.
//
// value: 'yes' | 'no' | ''. error: the inline message, shown under the radios.
function SmsConsentChoice({ yesText, noText, value, onChange, error }) {
  // The radios sit under Phone, near the top; Submit is at the bottom. Bring
  // the message to the visitor, as the form's error banner does.
  const ref = useRef(null);
  useEffect(() => {
    if (error && ref.current && typeof ref.current.scrollIntoView === 'function') {
      ref.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }, [error]);

  return (
    <fieldset
      ref={ref}
      className="sms-consent-choice"
      aria-required="true"
      aria-invalid={error ? 'true' : undefined}
      aria-describedby={error ? 'sms-consent-error' : undefined}
    >
      <legend className="sms-consent-legend">Text messages *</legend>
      <label className="terms-checkbox sms-consent">
        <input
          type="radio"
          name="smsConsentChoice"
          value="yes"
          checked={value === 'yes'}
          onChange={() => onChange('yes')}
        />
        <span>{yesText}</span>
      </label>
      <label className="terms-checkbox sms-consent">
        <input
          type="radio"
          name="smsConsentChoice"
          value="no"
          checked={value === 'no'}
          onChange={() => onChange('no')}
        />
        <span>{noText}</span>
      </label>
      {error && (
        <div id="sms-consent-error" className="sms-consent-error" role="alert">{error}</div>
      )}
    </fieldset>
  );
}

export default SmsConsentChoice;
